import { createTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Autocomplete,
  Box,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../assets/Customer/FilterIconHover.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import { listDoorsByAccessLevelId } from "../../slices/VisitorAccessLevels/VisitorAccessLevelSlice";
import { ThemeContext } from "../../theme/ThemeContext";

const MuiTheme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#36c96d",
    },
    secondary: {
      main: "#f50057",
    },
  },
});

const CustomIconLeft = styled(ChevronLeftIcon)(() => ({
  border: "1px solid green",
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: "green",
    color: "#FFFF",
  },
}));

const CustomIconRight = styled(ChevronRightIcon)(() => ({
  border: "1px solid green",
  borderRadius: "50%",
  "&:hover": {
    backgroundColor: "green",
    color: "#FFFF",
  },
}));

const useStyles = makeStyles((theme) => ({
  textarea: {
    resize: "both",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    background: "#3d4977",
    width: "100%",
    padding: "5px",
    textAlign: "center",
    borderRadius: "5px",
    color: "#FFFFFF",
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function AccessLevelFilter(props) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [door, setDoor] = useState();
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    name: "",
  });
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });

  const paging = {
    page: 1,
    rowsPerPage: 10000,
  };

  const defaultFilter = {
    accessGroupid: props.accGroupId,
    name: "",
  };
  useEffect(() => {
    if (open === true)
      dispatch(listDoorsByAccessLevelId(Object.assign(defaultFilter, paging)))
        .unwrap()
        .then((data) => {
          if (data.code === "DMSI0000") {
            setDoor(data.data.accessGroupDoors);
          }
        });
  }, [open]);

  const handleClose = () => {
    setFilterQuery(defaultFilter);
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const handleSubmit = () => {
    if (filterQuery.name === "") {
      Toast(t("COMMON015"), "error");
      return;
    }
    props.onSubmit(filterQuery);
    handleClose();
  };

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const reset = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };
  const doorNameField = () => {
    return (
      <Autocomplete
        popupIcon={<ExpandMoreIcon />}
        fullWidth
        noOptionsText={"No Options found"}
        name="name"
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option && option.name}
        options={!CommonUtil.isEmpty(door) ? door : []}
        onChange={(event, newValue) => {
          if (newValue !== null) setFilterQuery(newValue);
        }}
        renderInput={(params) => (
          <TextField {...params} label={t("DOOR_NAME")} />
        )}
      />
    );
  };
  return (
    <>
      <Tooltip
        title={
          <Typography fontSize={12} fontWeight={500}>
            {t("COMMON006")}
          </Typography>
        }
      >
        <span
          className={darkMode ? "filterdark" : "filter"}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={handleOpen}
        >
          {isHovered ? (
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <AccessLevelFilter />
            </FilterIconHover>
          ) : (
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <AccessLevelFilter />
            </FilterIcon>
          )}
        </span>
      </Tooltip>

      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={reset}
      >
        <Grid
          container
          rowSpacing={2}
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid item xs={12} sm={12}>
            {doorNameField()}
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
